import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie';

import store from '../store';
import routes from './routes'
import { settings } from '../settings'
import { setI18nLanguage } from '../setup/i18n-setup';

Vue.use(VueRouter)
/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

const currentLocale = 'en';
// Object of all localized paths (with the key mapping the route `name`)
const localizedRoutesPaths = {
    en: {
        hello: 'hello'
    },
    no: {
        hello: 'hi'
    }
};


// Recursive for loop adding the `path` and `alias` attributes to each localized route
function routeForEachHandler(route) {
    var lpath = localizedRoutesPaths[currentLocale];
    if (route.name && Object.prototype.hasOwnProperty.call(lpath, route.name)) {
        // Get route path in current language
        route.path = localizedRoutesPaths[currentLocale][route.name]

        // ONLY IF YOU NEED PATH NAMES TO WORK FOR ALL LANGUAGES
        // Get array of route paths of other languages for aliases
        route.alias = Object.keys(localizedRoutesPaths).reduce((accumulator, key) => {
            const localizedPath = localizedRoutesPaths[key][route.name]
            // Check if all true :
            // it's not the current language
            // it's not the same path name in this other language (otherwise it will create a infinite loop)
            // it's not already in the aliases list (otherwise it will also create a infinite loop)
            if (key !== currentLocale
                && localizedPath !== route.path
                && accumulator.indexOf(localizedPath) < 0
            ) {
                accumulator.push(localizedRoutesPaths[key][route.name]);
            }
            return accumulator;
        }, []);
    }

    if (route.children) {
        route.children.forEach(routeForEachHandler)
    }
}

routes.forEach(routeForEachHandler);




const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: routes
})
router.beforeEach(async (to, from, next) => {
    store.commit('app_settings/set_nav_bar_visible', false);




    if (to.path.startsWith('/odic') || to.path.startsWith('/static')) {
        next();
    }
    //else if (!store.getters['identity/authenticated'] && to.matched.some(record => record.meta.requiresAuth)) {
    //  await store.dispatch('identity/sign_in', to.fullPath);
    //  next(false);
    //}
    else {
        let languages = settings.languages.map(a => a.locale);
        let newLang = settings.default_locale;
        let cookieValue = Cookies.get('locale');

        let newPath = to.path;
        let newQuery = to.query;
        const { lang } = to.params;
        if (lang && languages.includes(lang)) {
            newLang = lang;
            store.dispatch('globalization/change_locale', newLang);
            if (cookieValue != newLang) {
                Cookies.set('locale', newLang);
            }
            setI18nLanguage(newLang);
            //loadLanguageAsync(newLang).then(() => {
            //});
        }
        else {

            if (cookieValue && languages.includes(cookieValue)) {
                newLang = cookieValue;
            }
            if (to.path === '/') {
                newPath = `/${newLang}`;
            }
            //else if (settings.auth.post_logout_redirect_uri.endsWith(to.path)) {
            //    newPath = `/${newLang}${to.path}`;
            //}
            else {
                newPath = `/${newLang}/not-found`;
            }
        }
        if (to.path !== newPath) {
            next({
                query: newQuery,
                path: newPath,
            })
        }
        else {

            //lang path ok, check other app requirement
            let redirect = false;
            if (!store.getters['identity/authenticated'] && to.matched.some(record => record.meta.requiresAuth)) {
                newPath = `/${newLang}/signin`
                newQuery.redirect_url = to.fullPath
                redirect = true;
            }


            if (redirect) {
                next({
                    query: newQuery,
                    path: newPath,
                })
            }
            else {
                if (to.meta.company_claims) {
                    if (store.getters['identity/user'].company_claims && to.meta.company_claims.every(v => store.getters['identity/user'].company_claims.map(cc => { return cc.claim_value }).includes(to.query.company_id + '.' + v))) {
                        next()
                    }
                    else {
                        newPath = `/${newLang}/unauthorized`;
                        next({
                            query: newQuery,
                            path: newPath,
                        })
                    }
                }
                else {
                    next()
                }
            }
        }



    }

});
export default router;